var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"electric-current-line-chart"},[_c('pub-info-title',{attrs:{"title":'桩端电流',"is-modal":true}}),_c('div',{staticClass:"chart-container"},[_c('pub-line-chart',{attrs:{"xAxisData":_vm.xAxisData,"seriesData":_vm.seriesData,"extraOption":_vm.extraOption}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }